import React from 'react';
// import React, { useState, useEffect } from 'react';
import { Image } from 'react-bootstrap';
import environment from '../../environment/environment';

const LoadingComponent = ({ data }) => {
    // const [message, setMessage] = useState(data.message);
    // const [type, setType] = useState(data.type);
    const logo = environment.logo;

    /* useEffect(() => {
        setMessage(data.message);  // Actualizar el mensaje si `data.message` cambia
        setType(data.type);        // Actualizar el tipo si `data.type` cambia
    }, [data]);  // Dependencia de `data`, se actualizará si `data` cambia */

    return (
        <div className="fixed top-0 right-0 h-screen w-screen z-40 flex justify-center items-center bg-gray-100 bg-opacity-30">
            <div className="relative flex justify-center items-center">
                <div className="animate-spin rounded-full w-64 h-64 border-t-8 border-b-8 border-[#136caf]"></div>
                <Image width={815} height={624} src={logo} className="absolute w-28 h-auto object-contain"/>
            </div>
        </div>
    );
};

export default LoadingComponent;